import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const RebublicDay = () => {  

  const images = [
    { id: 1, src: "images/rebublic/rebublic-1.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 2, src: "images/rebublic/rebublic-2.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 3, src: "images/rebublic/rebublic-3.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 4, src: "images/rebublic/rebublic-4.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 5, src: "images/rebublic/rebublic-5.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 6, src: "images/rebublic/rebublic-6.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 7, src: "images/rebublic/rebublic-7.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 8, src: "images/rebublic/rebublic-8.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 9, src: "images/rebublic/rebublic-9.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 10, src: "images/rebublic/rebublic-10.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 11, src: "images/rebublic/rebublic-11.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 12, src: "images/rebublic/rebublic-12.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 13, src: "images/rebublic/rebublic-13.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 14, src: "images/rebublic/rebublic-14.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 15, src: "images/rebublic/rebublic-15.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 16, src: "images/rebublic/rebublic-16.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 17, src: "images/rebublic/rebublic-17.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 18, src: "images/rebublic/rebublic-18.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 19, src: "images/rebublic/rebublic-19.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 20, src: "images/rebublic/rebublic-20.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 21, src: "images/rebublic/rebublic-21.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 22, src: "images/rebublic/rebublic-22.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 23, src: "images/rebublic/rebublic-23.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 24, src: "images/rebublic/rebublic-24.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
    { id: 25, src: "images/rebublic/rebublic-25.png", alt: "rebublic", title: "rebublic", group: "rebublic" },
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "77th Rebublic Day Celebration" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>77th Rebublic Day Celebration</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RebublicDay;
